import { render, staticRenderFns } from "./AddPriorityServiceSet.vue?vue&type=template&id=0a04540e&"
import script from "./AddPriorityServiceSet.vue?vue&type=script&lang=js&"
export * from "./AddPriorityServiceSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddPriorityServiceSet.vue"
export default component.exports